import { render, staticRenderFns } from "./PackageUser.vue?vue&type=template&id=f63f0484"
import script from "./PackageUser.vue?vue&type=script&lang=js"
export * from "./PackageUser.vue?vue&type=script&lang=js"
import style0 from "./PackageUser.vue?vue&type=style&index=0&id=f63f0484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports